// Copyright 2025-2026 Florian Gallon. All Rights reserved.
import React from 'react';

/**
 * AppShell — root wrapper that applies the themed background.
 * Replaces bare `min-h-screen bg-[var(--bg-secondary)]` or `bg-[var(--surface-card)]` patterns.
 */
const AppShell = ({ children, className = '' }) => {
  return (
    <div
      className={`min-h-screen overflow-x-hidden ${className}`}
      style={{ backgroundColor: 'var(--bg-primary)', color: 'var(--text-primary)' }}
    >
      {children}
    </div>
  );
};

export default AppShell;
